import { Checkbox } from '@digdir/designsystemet-react';
import { Fragment } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { OppvarmingFormData } from '../../../../types';
import { StyledCard } from '../../../../../../../../components/registering/steps/base/form/detailingSelect/components/styledComponents';
import { TermostatstyringGulvRadio } from '../../common/termostatstyringGulvRadio';
import { useElektrisitetValidation } from '../useElektrisitetValidation';
import { elektrisitetSelectionFields } from '../utils';
import { InstallasjonsArRadio } from '../../../../../../components/installasjonsArRadio';

export const GulvvarmeCheckbox = () => {
  const { t } = useTranslation();
  const { register, formState, watch } = useFormContext<OppvarmingFormData>();
  const { validateElektrisitetSelection } = useElektrisitetValidation();

  const isSelected = watch('elektrisk.value.gulvvarme.selected');
  const elektrisitetSelectionError = formState.errors?.elektrisk?.value?.gulvvarme?.selected;

  return (
    <StyledCard isActive={isSelected}>
      <Checkbox
        aria-invalid={!!elektrisitetSelectionError}
        label={t('form.oppvarming.elektrisitet.gulvvarme.label')}
        {...register('elektrisk.value.gulvvarme.selected', {
          validate: validateElektrisitetSelection,
          deps: elektrisitetSelectionFields,
          shouldUnregister: true
        })}
      />
      {isSelected && (
        <Fragment>
          <InstallasjonsArRadio
            name={`elektrisk.value.gulvvarme.value`}
            translationKeyPrefix={`form.oppvarming.elektrisitet.gulvvarme.installasjonsAr`}
          />
          <TermostatstyringGulvRadio name="elektrisk.value.gulvvarme.value.termostatstyring" />
        </Fragment>
      )}
    </StyledCard>
  );
};
